import { Component, Input } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { convertNumberToAcronyms } from "src/app/common/numberUtils";
import { aggregatedKeysSeparator as aggregatedKeysSeparator, AggregationDict } from "src/app/models/api/aggregations.model";
import { ISelectedFilters } from "src/app/models/filters/selectedFilters.interface";
import { FiltersQueryTransformer } from "src/app/services/filters/filtersQueryTransformer.ts/filtersQueryTransformer";

@Component({
    selector: "app-risk-mapping-score",
    templateUrl: "./risk-mapping-score.component.html",
    styleUrls: ["./risk-mapping-score.component.scss"],
})
export class RiskMappingScoreComponent {
    @Input() public seriesData: AggregationDict[];
    @Input() public filterOptions: ISelectedFilters;

    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
    ) {}

    public getScoresData(businessCriticalityVal: string, securityRiskVal: string) {
        const scoreValue = this.seriesData[0][`${businessCriticalityVal}${aggregatedKeysSeparator}${securityRiskVal}`] ?? 0;

        return convertNumberToAcronyms(scoreValue);
    }

    public goToInventoryPage(businessCriticalityVal: string, securityRiskVal: string) {
        const filtersQuery =
            FiltersQueryTransformer.transformToQuery(this.filterOptions) +
            ` businessCriticality:${businessCriticalityVal} securityRisk:${securityRiskVal}`;

        this._router.navigate(["inventory"], {
            relativeTo: this._activatedRoute,
            queryParams: { q: filtersQuery },
            queryParamsHandling: "merge",
        });
    }
}
